import {
    validateControlPersonRules,
    validateDuplicateContacts,
    validateOwnershipTotals,
    validateShareholderPercentages,
    validateUsSsnRequirement,
} from './helperV2';

const RECORD_VALIDATORS = [
    validateOwnershipTotals,
    validateControlPersonRules,
    validateDuplicateContacts,
    validateShareholderPercentages,
    validateUsSsnRequirement,
];

const INDIVIDUAL_KEY = /^individuals\[(\d+)\]\.(.+)$/;

const personLabel = (individual, index) => {
    const name = [individual?.firstName, individual?.lastName].filter(Boolean).join(' ').trim();
    return name || individual?.email || `Person ${index + 1}`;
};

export const runRecordValidators = (data) => {
    const errors = {};
    RECORD_VALIDATORS.forEach((validate) => {
        try {
            Object.assign(errors, validate(data) || {});
        } catch (e) {
        }
    });

    const individuals = Array.isArray(data?.individuals) ? data.individuals : [];
    const recordLevel = [];
    const fieldLevel = [];

    Object.entries(errors).forEach(([key, message]) => {
        if (!message) return;
        if (key.startsWith('_')) {
            recordLevel.push({ key, message });
            return;
        }
        const match = key.match(INDIVIDUAL_KEY);
        if (match) {
            const index = Number(match[1]);
            fieldLevel.push({
                key,
                message,
                index,
                field: match[2],
                person: personLabel(individuals[index], index),
            });
            return;
        }
        fieldLevel.push({ key, message, field: key });
    });

    return {
        errors,
        recordLevel,
        fieldLevel,
        hasErrors: recordLevel.length > 0 || fieldLevel.length > 0,
    };
};

export default runRecordValidators;

